import { render, staticRenderFns } from "./CallsStatisticsWidget.vue?vue&type=template&id=ac534294&scoped=true"
import script from "./CallsStatisticsWidget.vue?vue&type=script&lang=js"
export * from "./CallsStatisticsWidget.vue?vue&type=script&lang=js"
import style0 from "./CallsStatisticsWidget.vue?vue&type=style&index=0&id=ac534294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac534294",
  null
  
)

export default component.exports